export default [
  {
    title: 'Zelo',
    image: './uploads/partners/zelo.png'
  },
  {
    title: 'Abreu Locações e Terraplanagens',
    image: './uploads/partners/abreu.png'
  },
  {
    title: 'Coimbra Imobiliária',
    image: './uploads/partners/coimbra.png'
  },
  {
    title: 'Âncora Imobiliária',
    image: './uploads/partners/ancoraimob.png'
  }
]
